import apiHandler from "../core/apiHandler";

const rolePermissionsApi = apiHandler('role-permissions');
export default rolePermissionsApi;
